import { createSelector } from 'reselect';
import {ActionReducer, ActionReducerMap, createFeatureSelector, compose} from '@ngrx/store';
import * as fromRoot from '../../../app.reducer';
import { combineReducers } from '@ngrx/store';

import * as fromDocument from './document';

export interface DocumentState {
  document: fromDocument.State;
}

export interface State extends fromRoot.State {
  document: DocumentState;
}

export const initialState: DocumentState = {
  document: fromDocument.initialState
};

export const reducers = {
  document: fromDocument.reducer
};

export const keys = [
  'document'
];

export const getDocumentFeatureState = createFeatureSelector<DocumentState>('document');
export const getDocumentState = createSelector(getDocumentFeatureState,  (state: DocumentState) => state.document);

export const getCurrentFile = createSelector(getDocumentState, fromDocument.getCurrentFile);
export const getCurrentFileIds = createSelector(getDocumentState, fromDocument.getCurrentFileIds);
export const getDocuments = createSelector(getDocumentState, fromDocument.getDocuments);
export const getDocumentWorking = createSelector(getDocumentState, fromDocument.getWorking);
export const getIsDocumentListDeleted = createSelector(getDocumentState, fromDocument.getIsDeleted);
export const getDocumentUploading = createSelector(getDocumentState, fromDocument.getUploading);
export const getFilename = createSelector(getDocumentState, fromDocument.getFilename);
export const getSortField = createSelector(getDocumentState, fromDocument.getSortField);
export const getAscending = createSelector(getDocumentState, fromDocument.getAscending);
export const getDocumentDownloading = createSelector(getDocumentState, fromDocument.getDownloading);
export const getFileUrl = createSelector(getDocumentState, fromDocument.getUrl);



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/reducers/index.ts